import { Controller } from "@hotwired/stimulus"

export default class SelectOtherController extends Controller {
  static targets = ["typeSelect", "otherText"]
  static classes = ["hidden"]
  static values = { typeId: String }

  toggleOther() {
    if (this.typeIdValue == this.typeSelectTarget.value) {
      this.otherTextTarget.classList.remove(this.hiddenClass)
    }
    else {
      this.otherTextTarget.classList.add(this.hiddenClass)
    }
  }
}
